module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/mixed_desktop2-d2e70a340032c68590cf7df98722e564.jpg";